import { makeStyles } from "@mui/styles";
import { colors, Commons } from "../../../styleguide";

import FraventsBackground from "../../../assets/images/header_handshake.png";

const styles = makeStyles({
  container: {
    position: "relative",
    backgroundColor: colors.black,
    width: "100%",
    height: "100%",
    overflow: "auto",
    maxHeight: "100vh",
    maxWidth: "100vw",
    ...Commons.coverBackground,
    backgroundImage: `url("${FraventsBackground}")`,
    backgroundPosition: "right top",
    [Commons.smallQuery]: {
      backgroundSize: "contain",
    },
  },
  background: {
    position: "fixed",
    width: "100vw",
    bottom: 0,
    right: 0,
    objectFit: "cover",
    objectPosition: "right top",
    zIndex: 0,
    [Commons.smallQuery]: {
      bottom: "unset",
      top: 0,
      right: 0,
    },
  },
  scrollContainer: {
    position: "relative",
    zIndex: 0,
    padding: "12px 18px 120px 18px",
    maxWidth: 420,
    margin: "30dvh auto 0 auto",
    backgroundColor: `${colors.black}75`,
    borderRadius: "30px 30px 0 0",
    boxSizing: "border-box",
    minHeight: "calc(70dvh - 28px)",
    [Commons.smallQuery]: {
      backgroundImage: "linear-gradient(transparent 0.01%, black)",
      backgroundColor: colors.black,
      margin: "calc(56vw - 18px) auto 0 auto",
    },
  },
  profileImage: {
    ...Commons.centerHorizontal,
    width: 150,
    aspectRatio: "1 / 1",
    margin: "-120px auto 0 auto",
    backgroundColor: colors.themeColor,
    border: `6px solid ${colors.black}`,
    borderRadius: "50%",
    objectFit: "cover",
    [Commons.smallQuery]: {
      width: 120,
    },
  },
  title: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: 600,
    color: colors.white,
    backgroundColor: colors.black,
    width: "fit-content",
    margin: "0 auto 12px auto",
    borderRadius: 18,
    padding: "3px 18px",
  },
  iconSocial: {
    ...Commons.defaultButton,
    "& svg": {
      color: colors.white,
      fontSize: 24,
      backgroundColor: colors.black,
      borderRadius: 24,
      padding: 8,
      border: `2px solid ${colors.white}50`,
    },
  },
  buttonLink: {
    ...Commons.defaultButton,
    textAlign: "center",
    color: colors.white,
    backgroundColor: colors.themeColor,
    width: "100%",
    borderRadius: 30,
    padding: "12px 6px",
    marginBottom: 24,
    fontSize: 18,
    fontWeight: 600,
    boxShadow: `0px 1px 6px 5px ${colors.themeColor}50`,
  },
  buttonLinkWhite: {
    ...Commons.defaultButton,
    textAlign: "center",
    color: colors.themeColor,
    backgroundColor: colors.white,
    width: "100%",
    borderRadius: 30,
    padding: "12px 6px",
    marginBottom: 24,
    fontSize: 18,
    fontWeight: 600,
    boxShadow: `0px 1px 6px 5px ${colors.themeColor}50`,
  },
  mainVideo: {
    ...Commons.defaultButton,
    backgroundColor: colors.black,
    borderRadius: 12,
    boxShadow: `0px 1px 6px 5px ${colors.themeColor}50`,
    gap: 12,
    marginBottom: 24,
    border: `3px solid ${colors.themeColor}`,
    width: "100%",
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  containerImageMainVideo: {
    width: "100%",
    overflow: "hidden",
    borderRadius: 12,
    aspectRatio: "16 / 9",
    position: "relative",
    zIndex: 0,
  },
  imageMainVideo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  infoMainVideo: {
    position: "absolute",
    backgroundColor: `rgba(0,0,0,.75)`,
    width: "100%",
    bottom: 0,
    zIndex: 1,
    boxSizing: "border-box",
    borderRadius: "18px 18px 0 0",
    padding: 12,
    left: 0,
    overflow: "auto",
    maxHeight: "75%",
  },
  labelMainVideo: {
    margin: 0,
    color: colors.themeColor,
    textAlign: "right",
    fontWeight: 700,
    fontSize: 14,
    marginTop: 12,
    WebkitTextStroke: "1px #ffffff70",
  },
  titleMainVideo: {
    fontSize: 18,
    fontWeight: 600,
    margin: "0 0 12px 0",
    lineHeight: "22px",
    textAlign: "left",
    color: colors.white,
    ...Commons.ellipsis,
  },
  descriptionMainVideo: {
    ...Commons.ellipsis,
    fontSize: 12,
    margin: 0,
    textAlign: "left",
    color: colors.white,
  },
  footer: {
    ...Commons.flexCenter,
    padding: 18,
    fontWeight: 600,
    textAlign: "center",
    backgroundColor: colors.black,
    color: colors.white,
    borderRadius: "18px 18px 0 0",
    width: "100%",
    marginTop: 24,
    position: "fixed",
    boxSizing: "border-box",
    bottom: 0,
    left: 0,
    boxShadow: colors.shadowWhite,
  },
  description: {
    color: colors.white,
    textAlign: "center",
    fontSize: 16,
    fontWeight: 500,
    margin: "0 0 30px 0 ",
  },
});

export default styles;
